import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c0870226"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 排課管理 ", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "帳務管理", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_Setting = _resolveComponent("Setting")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createBlock(_component_el_menu, {
    class: "asideMenu",
    ref: "menu",
    "unique-opened": false,
    "default-active": '/' + _ctx.route.path.split('/')[1],
    "default-openeds": _ctx.openList,
    onSelect: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('OnMenuItemSelect'))),
    router: true,
    "background-color": "#CCA596",
    "text-color": "#fff",
    "active-text-color": "#526E60"
  }, {
    default: _withCtx(() => [
      (_ctx.isShowMenu)
        ? (_openBlock(), _createBlock(_component_el_menu_item, {
            key: 0,
            index: "/courseScheduling"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_Calendar)
                ]),
                _: 1
              }),
              _hoisted_1
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isShowMenu)
        ? (_openBlock(), _createBlock(_component_el_menu_item, {
            key: 1,
            index: "/accesscontrol"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_Calendar)
                ]),
                _: 1
              }),
              _createElementVNode("span", null, _toDisplayString(_ctx.t("Access Control")), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_el_menu_item, { index: "/qrcode" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_component_Menu)
            ]),
            _: 1
          }),
          _createElementVNode("span", null, _toDisplayString(_ctx.t("QRcode")), 1)
        ]),
        _: 1
      }),
      (_ctx.isShowMenu)
        ? (_openBlock(), _createBlock(_component_el_menu_item, {
            key: 2,
            index: "/temporaryqrcode"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_Menu)
                ]),
                _: 1
              }),
              _createElementVNode("span", null, _toDisplayString(_ctx.t("Temporary QRcode")), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_el_menu_item, { index: "/accountMgmt" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_component_Setting)
            ]),
            _: 1
          }),
          _createElementVNode("span", null, _toDisplayString(_ctx.t("Account_Mgmt_Music")), 1)
        ]),
        _: 1
      }),
      (_ctx.isShowMenu)
        ? (_openBlock(), _createBlock(_component_el_menu_item, {
            key: 3,
            index: "/closeAccountMgmt"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_Setting)
                ]),
                _: 1
              }),
              _hoisted_2
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["default-active", "default-openeds"]))
}